module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "right-panel md-elevation-3",
    attrs: {
      "id": "task-logs"
    }
  }, [_c('div', {
    staticClass: "md-layout-row"
  }, [_c('div', {
    staticClass: "md-flex"
  }, [_c('md-button', {
    staticClass: "md-icon-button md-dense",
    attrs: {
      "to": {
        name: 'Task',
        params: {
          projectid: this.$route.params.projectid,
          taskid: this.$route.params.taskid
        },
        query: {
          search: _vm.$route.query.search,
          responsible_id: _vm.$route.query.responsible_id,
          responsible: _vm.$route.query.responsible
        }
      }
    }
  }, [_c('md-icon', [_vm._v("arrow_back")])], 1)], 1)]), _c('md-table', {
    attrs: {
      "md-theme": "white"
    }
  }, _vm._l((_vm.logs), function(log) {
    return _c('md-table-row', {
      key: log.id
    }, [_c('md-table-cell', [_c('div', {
      staticClass: "text",
      domProps: {
        "innerHTML": _vm._s(log.description)
      }
    })]), _c('md-table-cell', {
      staticClass: "time"
    }, [_vm._v(_vm._s(log.created_at))])], 1)
  }))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-74daedb6","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/tasks/views/TaskLogs.vue
// module id = 1196
// module chunks = 0